import { combineReducers } from 'redux';

import auth from './auth/reducer';
import user from './user/reducer';
import properties from './properties/reducer';
import property from './property/reducer';

export default combineReducers({
  auth,
  user,
  properties,
  property,
});
